module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/3/2-2bf73bf2fcb98b5fb65301b35c683737.jpg";